import { Check, ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Icon } from "./Icon";
import { DiscordIcon } from "./DiscordIcon";
import { DISCORD_URL } from "../../lib/site";

export const ProductDialog = ({ product, info, labels, open, onOpenChange, onBuy }) => {
  if (!product || !info) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="product-dialog"
        className="max-w-lg bg-[#0a0e14] border-white/10 text-white p-0 overflow-hidden gap-0"
      >
        <div className="relative h-40">
          <img src={product.image} alt="" className="h-full w-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e14] via-[#0a0e14]/40 to-transparent" />
          <div className="absolute bottom-4 left-6 flex items-center gap-3">
            <span className="h-11 w-11 rounded-xl bg-cyan-500/15 border border-cyan-500/30 grid place-items-center text-cyan-400 backdrop-blur">
              <Icon name={product.icon} className="h-5 w-5" />
            </span>
            <div>
              <DialogDescription className="font-mono text-[10px] uppercase tracking-widest text-cyan-400">
                {info.tag}
              </DialogDescription>
              <DialogTitle className="font-display font-bold text-lg leading-tight">{info.title}</DialogTitle>
            </div>
          </div>
        </div>

        <div className="p-6">
          <p className="text-sm text-slate-400 leading-relaxed">{info.long}</p>

          <div className="mt-5 font-mono text-[11px] uppercase tracking-widest text-slate-500">{labels.included}</div>
          <ul className="mt-3 space-y-2.5">
            {info.includes.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-slate-200">
                <Check className="h-4 w-4 text-cyan-400 mt-0.5 shrink-0" />
                {f}
              </li>
            ))}
          </ul>

          <div className="mt-7 pt-5 border-t border-white/5 flex items-center justify-between">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{labels.price}</div>
              <div className="font-display font-bold text-2xl text-gradient">{info.price}</div>
            </div>
            <a
              data-testid="dialog-buy-discord"
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => onBuy(product)}
              className="bg-brand text-[#080a0f] font-semibold text-sm px-5 py-3 rounded-full flex items-center gap-2 hover:shadow-[0_0_24px_rgba(56,189,248,0.45)] transition-shadow duration-300 active:scale-[0.97]"
            >
              <DiscordIcon className="h-4 w-4" />
              {labels.buyOnDiscord}
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
